import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { Log } from 'helpers/errorLogger';
/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-ignore
import { markdown as MD } from 'markdown';

export interface Props {
  unsafeMarkdown?: boolean;
  markdown: string;
  className?: string;
}

const Markdown: React.FC<Props> = ({ unsafeMarkdown = false, markdown, className }) => {
  const [safeMarkdown, setSafeMarkdown] = useState('');

  const [markdownStyle, setMarkdownStyle] = useState('');

  useEffect(() => {
    if (typeof markdown === 'string') {
      let extractedStyle = '';
      let markdownWithoutStyle = markdown;
      const styleRegex = /<style>([\s\S]*?)<\/style>/gi;
      let styleMatch;

      while ((styleMatch = styleRegex.exec(markdown))) {
        extractedStyle += styleMatch[1];
        markdownWithoutStyle = markdownWithoutStyle.replace(styleMatch[0], '');
      }

      // Sanitize style content by adding .prose in front of classes
      const sanitizedStyle = extractedStyle.replace(/(\.[\w-]+)|([a-zA-Z]+)(?=\s*\{)/g, '.prose $&');

      setMarkdownStyle(sanitizedStyle);
      setSafeMarkdown(DOMPurify.sanitize(MD.toHTML(markdownWithoutStyle)));
    }
  }, [markdown]);

  return (
    <div className={className}>
      <>
        {!unsafeMarkdown && markdownStyle && <style>{markdownStyle}</style>}
        <div dangerouslySetInnerHTML={{ __html: unsafeMarkdown ? markdown : safeMarkdown }} suppressHydrationWarning />
      </>
    </div>
  );
};

export default Markdown;
